import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { createPatch } from 'diff';
import * as Diff2Html from 'diff2html';

@Component({
    selector: 'app-text-diff',
    templateUrl: './text-diff.component.html',
    styleUrls: ['./text-diff.component.scss'],
    standalone: false
})
export class TextDiffComponent {

    diffHtml = "";

    /*private */_fileName = "";
    private _left = "";
    private _right = "";
    private _sideBySide = true;

    @Input()
    leftFileName = "";
    @Input()
    rightFileName = "";
    
    @Input()
    set fileName(value: string) {
        this._fileName = value;
        this.update();
    }

    @Input()
    set left(value: string) {
        this._left = value;
        this.update();
    }

    @Input()
    set right(value: string) {
        this._right = value;
        this.update();
    }

    @Input()
    set sideBySide(value: boolean) {
        this._sideBySide = value;
        this.update();
    }


    private update(): void {
        let diff = createPatch(this.fileName, this._left, this._right, "", "") ;
        this.diffHtml = Diff2Html.html(diff, {
            matching: "lines",
            outputFormat: this._sideBySide ? "side-by-side" : "line-by-line",
            drawFileList: false,
            srcPrefix: this.leftFileName,
            dstPrefix: this.rightFileName            
        });
    }

    @ViewChild('container', { static: true }) container!: ElementRef<HTMLDivElement>;

    setWidth(width: number): void {
        if (this.container) {
            this.container.nativeElement.style.width = width + 'px';
            this.container.nativeElement.style.maxWidth = width + 'px';
        }
    }

}
